import React, { useContext } from "react";
import { GlobalDataContext } from "../context/context";
import TransparentHeader from "../components/global/TransparentHeader";
import BaseLayout from "../components/global/BaseLayout";
import ValuesOne from "../components/values/ValuesOne";
import BlockFour from "../components/block/BlockFour";
import BlockThree from "../components/block/BlockThree";

function About() {
  const { rpdata } = useContext(GlobalDataContext);
  return (
    <BaseLayout PageName="About">
      <div className="md:max-w-full w-full">
        <TransparentHeader
          headertitle="About"
          Subheader="About"
          bgimg={`${rpdata?.stock?.[4]}`}
        />
        <BlockFour
          image1={rpdata?.stock?.[3]}
          image2={rpdata?.stock?.[2]}
          image3={rpdata?.stock?.[5]}
          title={rpdata?.dbSlogan?.[1].slogan}
          text={rpdata?.dbAbout?.[0]?.text}
          listAbout={true}
        />
        <ValuesOne image={rpdata?.stock?.[5]} />
        <BlockThree
          title={rpdata?.dbSlogan?.[2]?.slogan}
          text={rpdata?.dbAbout?.[1]?.text}
          image={rpdata?.stock?.[10]}
        />
      </div>
    </BaseLayout>
  );
}

export default About;
